import React from 'react';

const WidthContext = React.createContext({width: 'lg'});

export default WidthContext;